<template>
  <div>
    <!-- Base Date Picker -->
    <button type="button" class="dropdown" @click="showDateModal = true">
      <div>{{ dateText }}</div>
      <i class="ml-2 icn icn-chevron-down sm"></i>
    </button>

    <!-- Date Modal -->
    <div v-if="showDateModal" class="modal overflow-auto">
      <div class="card">
        <div class="header">
          <div class="title">
            <div class="flex flex-row space-x-6">
              <div v-for="(item, key, index) in presetDates" :key="index">
                <button
                  type="button"
                  :class="matchDate(item) ? 'date-selection selected' : 'date-selection'"
                  @click="setDateRange(item)"
                >
                  <!-- {{ tempRange }} -->
                  <!-- {{ item }} -->
                  {{ key }}
                </button>
              </div>
            </div>
          </div>
          <div class="close" @click="close()">
            <i class="icn icn-x sm"></i>
          </div>
        </div>
        <div class="content pt-6">
          <div class="flex flex-row bg-primary-100 items-center rounded">
            <div class="flex items-center mr-2 bg-primary-500 py-2 px-2 rounded-l text-white">
              <i class="icn icn-information-circle"></i>
            </div>
            <div class="py-2 pr-2 text-primary-600">Double click on a date to choose a single date</div>
          </div>
          <div class="flex flex-col justify-center items-center h-full mt-4">
            <v-date-picker ref="calendar" v-model="tempRange" color="green" :columns="2" is-range :max-date="maxDate" />
          </div>
        </div>
        <div class="flex flex-row justify-center items-center mb-6">
          <button type="button" @click="confirmedDate()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isSameDay, format, startOfToday, subDays, endOfToday, endOfYesterday } from 'date-fns';
import startOfYesterday from 'date-fns/startOfYesterday/index';

export default {
  name: 'DatePicker',

  data() {
    return {
      showDateModal: false,
      tempRange: {},
      dateText: '',
      presetDates: {
        Yesterday: { start: startOfYesterday(), end: endOfYesterday() },
        Today: { start: startOfToday(), end: endOfToday() },
        'Past 7 Days': { start: subDays(startOfToday(), 6), end: endOfToday() },
        'Past 30 Days': { start: subDays(startOfToday(), 29), end: endOfToday() },
      },
    };
  },

  props: {
    maxDate: {
      type: Date,
      default: () => new Date(),
    },
    dateRange: {
      type: Object,
      default: () => ({
        start: subDays(startOfToday(), 6),
        end: endOfToday(),
      }),
    },
  },

  watch: {
    dateRange(newRange) {
      this.tempRange = newRange;
      this.dateText = this.updateDateText();
    },
  },

  mounted() {
    this.tempRange.start = this.dateRange.start;
    this.tempRange.end = this.dateRange.end;
    this.dateText = this.updateDateText();
  },

  methods: {
    matchDate(date) {
      return isSameDay(date.start, this.tempRange.start) && isSameDay(date.end, this.tempRange.end);
    },
    async setDateRange(date) {
      const calendar = this.$refs.calendar;
      this.tempRange = date;
      await calendar.move(
        { month: new Date(this.tempRange.end).getMonth(), year: new Date(this.tempRange.end).getFullYear() },
        { position: 1, transition: 'slide-h' },
      );
    },
    updateDateText() {
      let text = `${format(this.tempRange.start, 'd/M/y')} - ${format(this.tempRange.end, 'd/M/y')}`;
      for (const [dateText, date] of Object.entries(this.presetDates)) {
        if (this.matchDate(date)) {
          text = dateText;
        }
      }
      return text;
    },
    close() {
      this.tempRange.start = this.dateRange.start;
      this.tempRange.end = this.dateRange.end;
      this.showDateModal = false;
    },
    confirmedDate() {
      this.$emit('dateSelected', this.tempRange);
      this.dateText = this.updateDateText();
      this.showDateModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.counter-badge {
  @apply flex-1 bg-white flex flex-col p-6 justify-between gap-y-2 rounded-lg;

  .counter {
    @apply text-4xl;
  }

  h2 {
    font-family: ui-sans-serif, system-ui !important;
    color: #9fa6b2;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
  }
}

.dropdown {
  @apply outline-none bg-white border-gray-300 text-gray-600;

  &:focus {
    @apply outline-none;
  }
}

.date-selection {
  @apply rounded-none flex-1 items-center px-4 py-2 text-sm font-medium text-gray-600 justify-center bg-white shadow-none border-t-0 border-l-0 border-r-0 border-b-2 border-white outline-none;

  &.selected {
    @apply border-primary-500;
  }
}
</style>
